/* globals ga */
const AnalyticsException = require('./analytics-exception');

class GoogleAnalytics {
  /**
   * Create an instance of the class
   *
   */
  constructor () {
    /**
     * DO NOT DELETE gatracker. Used for form goals when GTM is in use.
     * We must fetch the correct ga instance to push updates. ga(...) won't work.
     * @see https://stackoverflow.com/questions/15744042/events-not-being-tracked-in-new-google-analytics-analytics-js-setup#comment81498038_40761709
     */
    document.onreadystatechange = function () {
      // If the gatracker has already been set, do nothing.
      if (window.gatracker !== 'undefined') {
        return;
      }

      // If the ga tracker is coming from Google tag manager, prefer that
      // instance of GA.
      if (typeof window.ga !== 'undefined' && window.ga) {
        if (typeof window.ga.getAll === 'undefined') {
          return window.gatracker = window.ga;
        }

        // Return the first GA instance (usually the default).
        return window.gatracker = window.ga.getAll()[0];
      }

      if (typeof ga === 'undefined') {
        throw new AnalyticsException(
          'Cannot find Google Analytics (ga) service'
        );
      }

      // If th global ga layer is not available, fallback to the ga analytics
      // container.
      window.gatracker = ga;
    };
  }

  /**
   * Send a new goal to Google Analytics
   *
   * @param  {String}
   * @param  {String}
   */
  sendGoal (uri, type = 'pageview') {
    window.gatracker.set('page', uri);
    window.gatracker.send(type);
  }
}

module.exports = GoogleAnalytics;
